import React from "react";
import { Image } from "semantic-ui-react";
import Icon from "assets/icons/share.svg";

const ShareIcon = (props) => {
  return <Image src={Icon} {...props} />;
};

export default ShareIcon;
